import {useSearchParams} from 'next/navigation';

export function useSearchParamsCustom() {
  const params = useSearchParams();
  const urlSearchParams = new URLSearchParams(params.toString());
  return urlSearchParams;
}

export const makeQueryString = (params: Record<string, any>) => {
  const filteredParams = Object.entries(params).filter(
    ([, value]) => value !== '' && value?.length !== 0
  );
  return new URLSearchParams(filteredParams).toString();
};
